import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  response: null,
  error: null,
};

const updateSupportStatusSlice = createSlice({
  name: "updateSupportStatus",
  initialState,
  reducers: {
    updateSupportStatusRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateSupportStatusSuccess: (state, action) => {
      state.loading = false;
      state.response = action.payload;
    },
    updateSupportStatusError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateSupportStatusRequest,
  updateSupportStatusSuccess,
  updateSupportStatusError,
} = updateSupportStatusSlice.actions;

export default updateSupportStatusSlice.reducer;
